import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrganizationPermissions } from '../models/organization.model';
import { RoleService } from './role.service';

/**
 * UX convenience for the prototype: sends users without the permission back to Discover.
 * It is not a security control. The backend must enforce authorization later.
 */
export const requirePermission =
  (permission: keyof OrganizationPermissions): CanActivateFn =>
  () =>
    inject(RoleService).can(permission) ? true : inject(Router).createUrlTree(['/discover']);
